<!--
 * @Author: your name
 * @Date: 2020-09-14 10:02:55
 * @LastEditTime: 2020-09-14 10:55:08
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \jiachi-wap\src\views\About.vue
-->
<template>
<div class="about">
    <publicHead :background="bg" title="走进佳驰" en-title="ENTERING JIACHI" @check="check" :list="['关于佳驰','发展大事记','合作伙伴']" />
    <div class="wrap">
        <index id="index" />
        <history id="history" />
        <cooperative id="cooperative" />
    </div>
</div>
</template>

<script>
import index from "@/components/about/index";
import history from "@/components/about/history";
import cooperative from "@/components/about/cooperative";
export default {
    components: {
        index,
        history,
        cooperative,
    },
    data() {
        return {
            opt: 0,
            bg: require("../assets/img/about-top.png"),
        };
    },
    created() {},
    methods: {
        check(e) {
            if (e == 0) {
                document.getElementById('index').scrollIntoView(true)
            } else if (e == 1) {
                document.getElementById('history').scrollIntoView(true)
            } else {
                document.getElementById('cooperative').scrollIntoView(true)
            }
        },
    },
    mounted() {
        let index = document.getElementById("index").offsetTop;
        let history = document.getElementById("history").offsetTop;
        let cooperative = document.getElementById("cooperative").offsetTop;
        window.addEventListener("scroll", (e) => {
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            if (scrollTop <= history) {
                this.opt = 0;
            } else if (scrollTop >= history && scrollTop < cooperative) {
                this.opt = 1;
            } else {
                this.opt = 2;
            }
        });
    },
};
</script>

<style lang="less" scoped>
.wrap {
    padding-top: 1.38rem;
    background: rgb(246, 246, 246);
}
</style>
